export const API_ROUTES = {
  PAYWALL: '/api/paywall',
  INFO: '/info',
  DATA_PREPARER_INFO: '/api/infoparameter/getdatapreparerdownloadstatus?os=',
  DATA_PREPARER_VERSION: '/api/infoparameter/getdatapreparerlastversion',
  DATA_PREPARER_DOWNLOAD: '/api/datamanagement/DataPreparer?os=',
  AIRES_FILES_IS_EMPTY: '/api/datamanagement/airesfilesisempty',
  CDFI_STATS_DATA: '/api/cdfi/stats',
  CDFI_CHART_DATA: '/api/cdfi/chart',
  GET_SUBMISSIONS: '/api/submissions',
  UPLOAD_FILES: '/api/datamanagement/memberdata',
  PRE_QUALIFICATION_DATA: '/api/cdfi/memberexport',
  CROSS_SELL_LIST: '/api/cdfi/export',
  CDFI_LOAN_ORIGINATION_STATS: '/api/cdfi-loan-origination/stats',
  CDFI_LOAN_ORIGINATION_CHART: '/api/cdfi-loan-origination/chart',
  CDFI_TM_ANALYSIS_DETAILS: '/api/cdfi-loan-origination/export',
  ZIP_IA_OVERLAP_ANALYSIS: '/api/cdfi-loan-origination/export/zip-codes',
  SET_FISCAL_YEAR_END: '/api/cdfi-loan-origination/setfiscalyearend',
  FS_OPTION_ANALYSIS_DETAILS: '/api/account-holders/export',
} as const;
